import React from "react";
import SideBar from "../components/sidebar";
import Dropdowns from "../components/dropdowns";
import placeholder from "../img/uploadlaptimeplaceholder.png"

const UploadLaptimes = ({ showSidebar, isPremium, page, setPage, figureImage, setFigureImage }) => { 
    return (
        <div className="laptimes-container">
            {showSidebar || <SideBar setPage={setPage}/>}


            <div className="laptimes-content">
                <div className="laptimes-header">
                    Welcome to the laptime analysis hub!
                </div>

                <div className="laptimes-dropdowns">
                    <Dropdowns
                    isPremium={isPremium}
                    page={page}
                    setFigureImage={setFigureImage}
                    setPage={setPage}
                    />
                </div>

                <div className="laptimes-output">
                    <img src={figureImage}/>
                </div>
            </div>
        </div>
    )
}

export default UploadLaptimes; 